<!-- Cliente (Selecionado) — pedidos-cadastro.component.html:749-841
     Restyle (terceira rodada, "mudança considerável"): campos de exibição (somente leitura,
     sempre disabled no original) saem do padrão <input disabled> do Bootstrap e passam a usar
     o mesmo padrão visual do modal "Adicionar Itens" (pedido-itens-detalhe-painel: .pedido-itens-box
     rótulo pequeno + valor em destaque, .pedido-itens-badge para valores categóricos curtos) —
     nenhum valor/condição exibido muda, só a estrutura visual. -->
<div class="alert alert-danger mb-2" *ngIf="clienteSelecionado != null && clienteSelecionado.bloqueado === 1">
  <strong>CLIENTE BLOQUEADO</strong>
  <span *ngIf="clienteSelecionado.status_bloqueado"> — {{ clienteSelecionado.status_bloqueado }}</span>
</div>
<div class="pedido-cliente-info-linha">
  <div class="pedido-cliente-info-box pedido-cliente-info-box-sm" [class.pedido-cliente-info-invalido]="clienteInvalido">
    <div class="label">Código</div>
    <div class="value">{{ clienteSelecionado == null ? '-' : clienteSelecionado.codigo_no_erp_do_cliente }}</div>
  </div>
  <div class="pedido-cliente-info-box pedido-cliente-info-box-lg" [class.pedido-cliente-info-invalido]="clienteInvalido">
    <div class="label">Cliente</div>
    <div class="value">{{ clienteSelecionado == null ? '-' : clienteSelecionado.name }}</div>
  </div>
</div>
<div class="erro pt-1 mb-2" *ngIf="clienteInvalido">Cliente em branco!</div>
<div class="pedido-cliente-info-linha">
  <div class="pedido-cliente-info-box pedido-cliente-info-box-md">
    <div class="label">Endereço</div>
    <div class="value">{{ clienteSelecionado == null ? '-' : clienteSelecionado.endereco_completo }}</div>
  </div>
  <div class="pedido-cliente-info-box">
    <div class="label">CNPJ/CPF</div>
    <div class="value">{{ clienteSelecionado == null ? '-' : clienteSelecionado.client_document }}</div>
  </div>
  <div class="pedido-cliente-info-box">
    <div class="label">
      Notas Fiscais
      <ng-container *ngIf="clienteSelecionado != null && clienteSelecionado.client_document != null && clienteSelecionado.client_document != ''">
        <i class="fa fa-info label_acao ml-1" placement="top" ngbTooltip="Notas Fiscais" (click)="abrirNotasFiscais.emit(modalNotasFiscais)"></i>
      </ng-container>
    </div>
    <div class="value">
      <span class="pedido-cliente-badge" [class.pedido-cliente-badge-danger]="clienteSelecionado != null && clienteSelecionado.status_financeiro != null">
        {{ clienteSelecionado == null ? '-' : clienteSelecionado.status_financeiro != null ? 'INADIMPLENTE' : 'Regular' }}
      </span>
    </div>
  </div>
</div>
<!-- Segmentação do Cliente -->
<div class="pedido-cliente-segmentacao">
  <div class="pedido-cliente-badge-linha">
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.ramo_atividade">{{ clienteSelecionado.ramo_atividade }}</span>
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.segment">{{ clienteSelecionado.segment }}</span>
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.grupo_regiao">{{ clienteSelecionado.grupo_regiao }}</span>
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.subsegmento">{{ clienteSelecionado.subsegmento }}</span>
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.subsegmento2">{{ clienteSelecionado.subsegmento2 }}</span>
    <span class="pedido-cliente-badge" *ngIf="clienteSelecionado?.rede_postos">{{ clienteSelecionado.rede_postos }}</span>
  </div>
  <div class="pedido-cliente-info-linha mt-2" *ngIf="clienteSelecionado?.limite_credito_disponivel != null || clienteSelecionado?.credito_financeiro != null">
    <div class="pedido-cliente-info-box pedido-cliente-info-box-financeiro" *ngIf="clienteSelecionado?.limite_credito_disponivel != null">
      <div class="label">Limite Disponível</div>
      <div class="value">{{ clienteSelecionado.limite_credito_disponivel | currency: 'BRL' }}</div>
    </div>
    <div class="pedido-cliente-info-box pedido-cliente-info-box-financeiro" *ngIf="clienteSelecionado?.credito_financeiro != null">
      <div class="label">Crédito Disponível</div>
      <div class="value">{{ clienteSelecionado.credito_financeiro | currency: 'BRL' }}</div>
    </div>
  </div>
</div>
<hr class="mt-2 mb-2" />
